import { StoreState } from 'state/rootReducer';

export const getEmailIntegration = ({ onlinePayment }: StoreState) =>
  onlinePayment.checkout.successPayment.emailIntegration;
